<template>
  <section id="lead-detail">
    <div
      v-if="loading"
      class="ld-loading-container"
    >
      <img src="@shared/assets/img/general/loading-white.svg">
    </div>
    <div
      v-else
      ref="document"
      class="ld-content-container"
    >
      <PerformanceAlertPdf v-if="alert.category === 'Performance'" />
      <WaterLeakPdf v-else-if="alert.category === 'Leak'" />
    </div>
  </section>
</template>

<script>
import html2pdf from 'html2pdf.js';

import PerformanceAlertPdf from '@shared/components/leadDetailPdf/PerformanceAlertPdf.vue';
import WaterLeakPdf from '@shared/components/leadDetailPdf/WaterLeakPdf.vue';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'LeadDetailPdfView',
  components: {
    WaterLeakPdf,
    PerformanceAlertPdf,
  },
  mixins: [leadDetailMixin],
  async mounted() {
    if (this.isManufactureAdmin) {
      this.$router.replace('/quality');
    } else {
      window.onafterprint = () => {
        window.close();
      };
      await this.$store.dispatch('getLeadDetailForPdf', {
        noticeId: this.$route.params.leadId,
      });
      setTimeout(() => {
        this.exportToPDF();
      }, 1000);
    }
  },
  methods: {
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 0,
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      }).then(() => setTimeout(() => {
        // window.close();
      }, 1000));
    },
  },
};
</script>

<style lang="scss">

.row-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.ld-content-container {
  display: flex;
  width: 612pt;

  .side-padding {
    min-width: 94px;
  }

  .ld-top-container {
    display: grid;
    grid-template-columns: 50% 50%;
    min-height: 306pt;
  }

  .ld-bottom-container {
    display: grid;
    gap: 1rem;
    grid-auto-flow: column;
    padding: 1rem 2rem;
  }

  .ld-table-container {
    padding: 1rem 2rem;
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
  }
}

section#lead-detail {
  display: flex;
  justify-content: center;
  font-family: 'Gilroy', sans-serif;
  background-color: $WHITE;
  width: 612pt;
  margin-left: auto;
  margin-right: auto;
  box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
  color: $NAVY100;

  .ld-loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 800px;
    height: 100vh;
  }

  #waterleak-pdf {
    width: 100%;
  }
}

@media print {
  #navbar {
    visibility: hidden;
    display: none !important;
  }
  .ld-content-container * {
    visibility: visible;
  }
}
</style>
